export const ultimaActualizacion = '03/11/2026 13:56';
